<template>
  <div v-if="menus" class="menu-container">
    <TemplateSheetMenu :menus="menus" />
  </div>

  <DialogInitialLoading v-else />

  <!-- 認証失敗 -->
  <DialogQRAuthBadRequest ref="DialogQRAuthBadRequest" :isReturnSheet="true" />
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref, props } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

// Vueファイル
import TemplateSheetMenu from "@/views/Templates/MyTickets/TemplateSheetMenu";

// Service
import sheetService from "@/services/sheet";
import nativeHandlerService from "@/services/nativeHandler";

// API
import API from "@/API";

export default {
  name: "SheetMenu",
  components: {
    TemplateSheetMenu: TemplateSheetMenu,
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();

    const book = store.getters["ticketing/book"];
    const menus = computed(() => store.getters["ticketing/sheetMenus"]);

    const DialogQRAuthBadRequest = ref(null);

    const getMenu = async () => {
      try {
        // 救済コード入力の場合はそこでmenu取得するので、ない場合だけ一度取り直す
        if (menus.value == null) {
          const masterSheet = store.getters["ticketing/masterSheet"];
          // メニュー一覧の取得
          await API.getSheetMenus(
            masterSheet.id,
            route.query.location_id,
            route.query.onetime
          );
        }
      } catch (err) {
        console.log("Error in getMenu()", err);
        if (err.response.data.message == "利用対象外のコードです") {
          DialogQRAuthBadRequest.value.openDialog();
        }
      }
    };

    onMounted(async () => {
      try {
        // Storeにbook情報がなければ、シートフローの中で必要なAPIを取得し、それぞれのデータをstoreへcommit
        if (book.length == 0) {
          await sheetService.getSheetInfomations(route);
        }
        await getMenu();
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "SheetMenu onMounted()",
          JSON.stringify(err)
        );
      }
    });

    return {
      menus,
      DialogQRAuthBadRequest,
    };
  },
};
</script>

<style lang="scss" scoped>
.menu-container {
  width: 100vw;
}
</style>
